export default "__VITE_ASSET__DOMYWejp__"